import { useUnit } from 'effector-react';
import { Alert, Snackbar } from '@mui/material';
import { $error, clearError } from '../../model/main';

export const ErrorSnackbar = () => {
  const [error] = useUnit([$error]);

  return (
    <Snackbar
      open={!!error}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={5000}
      onClose={() => clearError()}
    >
      <Alert severity="error" variant="filled">
        {error?.message}
      </Alert>
    </Snackbar>
  );
};
